module.exports = __webpack_public_path__ + "static/media/BLK.6d7bc93f.png";